import './map.scss';
import React, {useCallback, useEffect} from 'react';
import {useStateContext} from '../../helpers/state-context/use_state_context.js';
import {BubbleMap} from './bubble-map.js';
import svgPanZoom from "svg-pan-zoom";
import {getSimpleReducer, StateContext} from "../../helpers/state-context.js";
import {categoriesMapping, getCategoryById} from "../categories/categories_mapping.js";
import {CircleIcon} from "../ui/circle-icon.js";
import PlusIcon from "../../assets/Zoom_in.svg";
import MinusIcon from "../../assets/Zoom_out.svg";
import parse from 'html-react-parser';
import Hammer from 'hammerjs'
import {Analytics} from '../../helpers/analytics';


function BubbleMapZoom(props) {
    const [state, dispatch] = useStateContext(['page', 'country', 'countryHover', 'categories', 'selectedCategory', 'pan', 'zoom']);
    const svgRef = useCallback((node)=>{
        if(node !== null && !state.pan) {

            const eventsHandler = {
                haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
                init: function(options) {
                    let instance = options.instance;
                    let initialScale = 1;
                    let pannedX = 0;
                    let pannedY = 0;

                    // Init Hammer
                    // Listen only for pointer and touch events
                    this.hammer = Hammer(options.svgElement, {
                        inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
                    })

                    // Enable pinch
                    this.hammer.get('pinch').set({enable: true})

                    // Handle double tap
                    this.hammer.on('doubletap', function(ev){
                        instance.zoomIn()
                    })

                    // Handle pan
                    this.hammer.on('panstart panmove', function(ev){
                        // On pan start reset panned variables
                        if (ev.type === 'panstart') {
                            pannedX = 0
                            pannedY = 0
                        }

                        // Pan only the difference
                        instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
                        pannedX = ev.deltaX
                        pannedY = ev.deltaY
                    })

                    // Handle pinch
                    this.hammer.on('pinchstart pinchmove', function(ev){
                        // On pinch start remember initial zoom
                        if (ev.type === 'pinchstart') {
                            initialScale = instance.getZoom()
                            instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
                        }

                        instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
                    })

                    // Prevent moving the page on some devices when panning over SVG
                    options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
                },
                destroy: function(){
                    this.hammer.destroy()
                }
            }

            // Calculate maximum panning

            // let beforePan = (oldPan, newPan) => {
            //     let svgNode = node.getBBox();
            //     let sizes = svgPan.getSizes();
            //     let gutterWidth = -svgNode.width + 500;
            //     let gutterHeight = -svgNode.height + 500;
            //
            //     let leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
            //     let rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom)
            //     let topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
            //     let bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)
            //
            //     let customPan = {};
            //     customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
            //     customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))
            //
            //     return customPan
            // };

            let svgPan = svgPanZoom(node, {
                dblClickZoomEnabled: false,
                zoomEnabled: true,
                zoomScaleSensitivity: 0.5,
                minZoom: 1,
                maxZoom: 3,
                fit: false,
                contain: false,
                center: true,
                onZoom: (value)=>{dispatch({type: 'zoom', value});},
                // beforePan: beforePan
                customEventsHandler: eventsHandler

            });

            dispatch({
                type: 'pan',
                value: svgPan
            })
        }
    }, [dispatch, state.pan]);

    useEffect(() => {
        return () => {
            if (state.pan) {
                state.pan.destroy();
            }
        }
    }, [state.pan]);

    let data = [];
    for (const country of props.resultSet.data.values) {
        if(country.country_code === "EU"){
            continue;
        }

        const categories = [];
        for(const [key, category] of categoriesMapping.entries()){
            const rawCountry = props.resultSet.data.raw.find((c)=>c.country_code === country.country_code)
            if(rawCountry && rawCountry[`category_${category.id}`] === true ){
                // If category 8 is true while there are other categories selected aswell skip category 8.
                if(key === 7 && rawCountry.category_8 === true && categories.length > 0){
                    break;
                }
                categories.push(category.id)
            }
        }
        if(categories.length === 0){
            categories.push(8)
        }

        const countriesEU = [
            "BE", "BG", "CZ", "DK", "DE", "EE", "IE", "EL", "ES", "FR", "HR", "IT", "CY",
            "LV", "LT", "LU", "HU", "MT", "NL", "AT", "PL", "PT", "RO", "SI", "SK", "FI",
            "SE"
        ];

        // hover europe icon
        if ((state.countryHover && state.countryHover === 'EU' && countriesEU.includes(country.country_code) && state.categories.some((category) => categories.includes(category))) ||
                // hover active countries
                (state.countryHover === 'active_countries' && country.is_active && state.categories.some((category) => categories.includes(category))) ||
                // hover single country
                (state.countryHover && state.countryHover === country.country_code) ||
                // not hover
                (!state.countryHover && state.categories.some((category) => categories.includes(category)))
        ) {
            const minCategory = Math.min(...categories);

            let color = getCategoryById(minCategory).color;

            if(state.selectedCategory){
                color = getCategoryById(state.selectedCategory).color
            }

            if(state.categories && state.categories.length === 1){
                color = getCategoryById(state.categories[0]).color
            }

            // Set color to darkgrey if category 8
            if(state.categories.includes(8)){
                color = 'darkgrey'
            }
            data.push({
                country: country.country_code,
                categories: categories,
                is_active: country.is_active,
                percentage: 1,
                value: 1,
                title: parse(country.country_name || ""),
                color: color
            })
        }
    }

    return <>
        <BubbleMap svgRef={svgRef}
                onSelect={(country) => {
                    if(!state.categories.includes(8)) {
                        Analytics.trackEvent({
                            action: 'select country',
                            category: 'map',
                            label: country.title
                        });
                        dispatch({type: 'country', value: country.country});
                    }
                }}
                onMouseEnter={(country)=>{
                    dispatch({type: 'countryHover', value: country.country})
                    // JV: Normally countries that we can hover have information (so it should't have
                    // category 8), however it seems this does sometime happen (Poland). Selecting
                    // category 8 messes up things, so we exclude it from the list.
                    // it seems country.category is not always defined here... So we need to check for
                    // that first.
                    dispatch({
                        type: 'categories',
                        value: country.categories
                    });

                }}
                onMouseLeave={()=>{
                    dispatch({type: 'countryHover', value: null});
                    if(state.page !== 'country'){
                        if (state.selectedCategory) {
                            dispatch({type: 'categories', value: [state.selectedCategory]});
                        } else {
                            dispatch({type: 'setDefaultCategories'})
                        }
                    }
                }}
                className={'zol-map'} dimension={'country'} data={data} state={state}
                height="full"/>
        <div style={{
            position: 'fixed',
            right: '1%',
            bottom: '1%',
            color: 'rgb(29, 43, 125)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: 10
        }}>
            <CircleIcon style={{backgroundColor: '#fff'}}
                    onClick={() => {
                        if(state.pan){
                            const svgViewPort = document.getElementsByClassName(
                                "svg-pan-zoom_viewport"
                            )[0].getBBox();
                            if(svgViewPort){
                                // Calculate center point of viewport and zoom by 150%;
                                state.pan.zoomAtPointBy(
                                    1.5,
                                    {
                                        x: (svgViewPort.x+svgViewPort.width)/2,
                                        y: (svgViewPort.y+svgViewPort.height)/2
                                    }
                                );
                            }
                        }
                    }}
                    src={PlusIcon} alt={'plus_icon'}/>
            <CircleIcon style={{backgroundColor: '#fff'}}
                    onClick={() => {
                        if(state.pan){
                            const svgViewPort = document.getElementsByClassName(
                                "svg-pan-zoom_viewport"
                            )[0].getBBox();
                            if(svgViewPort){
                                // Calculate center point of viewport and zoom by 50%;
                                state.pan.zoomAtPointBy(
                                    .5,
                                    {
                                        x: (svgViewPort.x+svgViewPort.width)/2,
                                        y:(svgViewPort.y+svgViewPort.height)/2
                                    }
                                );
                            }

                        }
                    }}
                    src={MinusIcon} alt={'minus_icon'}/>
        </div>
    </>;
}

function BubbleMapZoomable(props){
    return <StateContext initialState={{pan: undefined, zoom: 1}} reducer={getSimpleReducer(['pan', 'zoom'])}>
        <BubbleMapZoom {...props}/>
    </StateContext>
}

BubbleMapZoomable.defaultProps = {
    resultSet: {
        status: 'inactive',
        data: [
            {country: 'CN', categories: [2, 4, 7], percentage: 1, value: 1, title: 'Armenia', color: '#3660b7'},
            {country: 'BR', categories: [1, 5], percentage: 1, value: 1, title: 'Brazil', color: '#8bbf2e'},
            {country: 'IE', categories: [2, 6], percentage: 1, value: 1, title: 'Bosnia-Herz.', color: '#3660b7'},
            {country: 'US', categories: [3, 8], percentage: 1, value: 1, title: 'Bosnia-Herz.', color: '#e74e4e'},
        ]
    },
    linkedState: ['region', 'country'],
    colorScaleType: 'continuous',
    colorScaleLabel: (value) => (
        value < 1 ? 'low' : (value > 2 ? 'high' : 'medium')
    ),
    bubbleScaleLabel: 'Number of items'
};

export {BubbleMapZoomable}